import { observer } from 'mobx-react-lite'
import { type MotionValue } from 'motion/react'
import { Button } from '@/components/Button'
import {
  StickyViewHeader,
  StickyViewHeaderExtras,
  StickyViewHeaderMain,
} from '@/components/StickyViewHeader'
import { WorkspaceSelectorViewHeadingContainer } from '@/features/iam/workspaces/components/WorkspaceSelectorViewHeading/WorkspaceSelectorViewHeadingContainer'
import { type UserManagementViewModel } from '@/features/user-management/UserManagement/UserManagementViewModel'

export interface UserManagementWorkspaceSwitcherContainerProps {
  scrollOffset: MotionValue<number>
  vm: UserManagementViewModel
}

export const UserManagementWorkspaceSwitcherContainer = observer(
  function UserManagementWorkspaceSwitcherContainer({
    scrollOffset,
    vm,
  }: UserManagementWorkspaceSwitcherContainerProps) {
    const workspaceSelectorVm = vm.workspaceSelector
    return (
      <StickyViewHeader scrollOffset={scrollOffset} flush>
        <StickyViewHeaderMain>
          <WorkspaceSelectorViewHeadingContainer
            primaryText="User Management"
            dropdownTitle="Select Workspace"
            allOptionText={
              workspaceSelectorVm.canManageAll ? 'All workspaces' : null
            }
            workspaces={workspaceSelectorVm.filteredWorkspaces}
            value={workspaceSelectorVm.selectedWorkspace}
            onChange={workspaceSelectorVm.selectWorkspace}
            searcher={workspaceSelectorVm}
            alwaysUseDropdown={true}
          />
        </StickyViewHeaderMain>
        {workspaceSelectorVm.canInviteUsers && (
          <StickyViewHeaderExtras>
            <Button
              label="Invite"
              variant="secondary"
              testId="user-management-invite-button"
              onPress={vm.workspaceInvitationVm.showWithSelections}
            />
          </StickyViewHeaderExtras>
        )}
      </StickyViewHeader>
    )
  },
)
